import { useEffect } from "react";

export const useFieldValue = ({
	fieldRef,
	fields,
	setValue,
	updateFieldInStore,
	condition,
}) => {
	useEffect(() => {
		if (condition && !fieldRef?.current) {
			fields.forEach((field) => {
				if (field.value) {
					setValue(field.name, field.value);
					updateFieldInStore({ id: field.name, value: field.value });
				}
			});

			fieldRef.current = true;
		}
	}, [condition, fields, fieldRef, setValue, updateFieldInStore]);
};
